module.exports = __webpack_public_path__ + "img/Führungstrupp.f38d620d.svg";